const set_percent_additional = (item, field) => {
  let result = item[field];
  let percent_field = `${field}_percent`;

  if (item.hasOwnProperty(percent_field)) {
    result = `${result} (${item[percent_field]}%)`;
  }

  return result;
};

export default {
  namespaced: true,
  state     : {
    employee_study_directorate: {
      content: {
        search    : '',
        pagination: {
          sortBy     : 'name',
          rowsPerPage: 10,
        },
        headers: [
          {text: 'Управление', value: 'name'},
          {text: 'Кол-во курсов', value: 'all_course_count'},
          {text: 'Статус "Новый"', value: 'new_course_count'},
          {
            text       : 'Статус "Идет обучение"',
            value      : '',
            inner_items: [
              {
                text : 'Не просрочен',
                value: 'not_expired_course_history_count',
              },
              {
                text : 'Просрочен',
                value: 'expired_course_history_count',
              },
            ],
          },
          {text: 'Статус "Завершен"', value: 'completed_course_count'},
          {text: 'Ср. балл', value: 'average_users_points'},
          // {
          //   text       : 'Результаты теста',
          //   value      : '',
          //   inner_items: [
          //     {
          //       text : 'Выше порога',
          //       value: 'test_passed',
          //     },
          //     {
          //       text : 'Ниже порога',
          //       value: 'test_not_passed',
          //     },
          //     {
          //       text : 'Ср. балл',
          //       value: 'test_average',
          //     },
          //   ],
          // },
        ],
        body: [
          {
            name                            : '',
            all_course_count                : 1254,
            new_course_count                : '23',
            not_expired_course_history_count: '11',
            expired_course_history_count    : '12',
            completed_course_count          : '123',
            average_users_points            : '43',
          },
        ],
      },
    },
    showed_directorate_filter: false,
    example_directorate      : {
      id           : 50,
      name         : 'Управление пример',
      courses_stats: {
        total      : 500,
        new        : 20,
        finished   : 100,
        in_progress: 380,
        not_overdue: 300,
        overdue    : 80,
      },
    },
  },
  getters: {
    example_directorate       : ({example_directorate}) => example_directorate,
    showed_directorate_filter : ({showed_directorate_filter}) => showed_directorate_filter,
    employee_study_directorate: ({employee_study_directorate}) => employee_study_directorate,
    get_directorate_by_id     : ({employee_study_directorate}, {}, {route}, rootGetter) => {
      let current_id = route.query.directorate;
      let result = employee_study_directorate.content.body.find((item)=>item.id==current_id);
      return result;
    },
  },
  mutations: {
    // CLOSE_MODAL(state, type) {
    //   let modal = state.modals.find((modal)=> modal.type === type);
    //   modal.active = false;
    // },
    // OPEN_MODAL(state, type) {
    //   let modal = state.modals.find((modal)=> modal.type === type);
    //   if (!modal.active) {
    //     modal.active = true;
    //   }
    // },
    TOGGLE_DIRECTORATE_FILTER(state) {
      state.showed_directorate_filter = !state.showed_directorate_filter;
    },
    SHOW_DIRECTORATE_NUMBER(state, selected) {
      let table = state.employee_study_directorate.content;
      if (selected=='Показывать по 10') {
        table.pagination.rowsPerPage = 10;
      } else if (selected=='Показывать по 25') {
        table.pagination.rowsPerPage = 25;
      } else if (selected=='Показывать по 50') {
        table.pagination.rowsPerPage = 50;
      } else if (selected=='Показывать по 100') {
        table.pagination.rowsPerPage = 100;
      }
    },
    SET_DIRECTORATE_PAGINATION(state, value) {
      let table = state.employee_study_directorate.content;
      table.pagination = value;
    },
    SET_DIRECTORATE_PAGE(state, value) {
      let table = state.employee_study_directorate.content;
      table.pagination.page = value;
    },
    CHANGE_DIRECTORATE_SORT(state, column) {
      let table = state.employee_study_directorate.content;
      if (table.pagination.sortBy === column) {
        table.pagination.descending = !table.pagination.descending;
      } else {
        table.pagination.sortBy = column;
        table.pagination.descending = false;
      }
    },
    SEARCH_DIRECTORATE(state, value) {
      state.employee_study_directorate.content.search = value;
    },

    SET_COMPANIES(state, value) {
      let new_value = [];
      value.forEach((item, idx)=>{
        new_value.push({});
        new_value[idx].organization_id = item.organization_id;
        new_value[idx].name = item.name;
        new_value[idx].all_course_count = item.all_course_count;
        new_value[idx].new_course_count = set_percent_additional(item, 'new_course_count');
        new_value[idx].not_expired_course_history_count = set_percent_additional(item, 'not_expired_course_history_count');
        new_value[idx].expired_course_history_count = set_percent_additional(item, 'expired_course_history_count');
        new_value[idx].completed_course_count = set_percent_additional(item, 'completed_course_count');
        new_value[idx].average_users_points = item.average_users_points;
      });
      state.employee_study_directorate.content.body = new_value;
    },
  },
};
